import type { ClientProfileAddress } from '../model/client.types';

// `street2` (the apt or unit) is stored as '' rather than null when blank, so it is dropped by
// emptiness, not by a null check.
export function formatAddressStreet(address: ClientProfileAddress | null): string {
    if (!address) return '';

    return [address.street1, address.street2].filter((part) => part.trim() !== '').join(', ');
}
